var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 71,
    viewBox: "0 0 78 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3902 0H26.6098C21.5247 0 16.8397 2.69621 14.2971 7.07433L1.90692 28.4257C-0.635642 32.8038 -0.635642 38.1962 1.90692 42.5743L14.2971 63.9257C16.8397 68.3038 21.5376 71 26.6098 71H51.3902C56.4753 71 61.1603 68.3038 63.7029 63.9257L76.0931 42.5743C78.6356 38.1962 78.6356 32.8038 76.0931 28.4257L63.7029 7.07433C61.1603 2.69621 56.4624 0 51.3902 0Z",
    fill: "#AD784C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2815 32.9443H31.3207V39.4281C31.3207 40.9816 32.2758 42.0087 33.8504 42.0087C35.425 42.0087 36.38 40.9816 36.38 39.4281V32.9443H38.4193V39.5693C38.4193 42.0215 36.7801 43.9602 33.8504 43.9602C30.9206 43.9602 29.2815 42.0215 29.2815 39.5693V32.9443Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9747 32.9443H43.4011L46.0211 36.7062L48.6153 32.9443H51.0547L47.5441 38.0543L51.4031 43.7163H48.9251L46.0211 39.4794L43.1172 43.7163H40.6392L44.4982 38.0543L40.9876 32.9443H40.9747Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUx);
export default __webpack_public_path__ + "static/media/ux.affb7944714e79921f5b85fa77c9e25c.svg";
export { ForwardRef as ReactComponent };